// extracted by mini-css-extract-plugin
export var orderSummary = "_lf-0";
export var showMoreLessButton = "_lf-1";